import { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { getCategoryLabel, getUnitLabel, fileUrl } from "../lib/api";
import { useI18n } from "../i18n/I18nProvider";

const AMSTERDAM_FALLBACK = [52.370216, 4.895168];

const brickIcon = L.divIcon({
  className: "",
  html: '<div style="background:#C5533B;width:18px;height:18px;border:2px solid #1C1C1A;transform:rotate(45deg);box-shadow:2px 2px 0 #1C1C1A"></div>',
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

function FitBounds({ points }) {
  const map = useMap();
  useMemo(() => {
    if (!points.length) return;
    if (points.length === 1) {
      map.setView(points[0], 11);
    } else {
      const bounds = L.latLngBounds(points);
      map.fitBounds(bounds, { padding: [40, 40] });
    }
  }, [points, map]);
  return null;
}

export default function MapView({ listings, center }) {
  const { t, lang } = useI18n();
  const placed = useMemo(() => listings.filter((l) => l.lat != null && l.lng != null), [listings]);
  const points = useMemo(() => placed.map((l) => [l.lat, l.lng]), [placed]);
  const initial = useMemo(() => center || points[0] || AMSTERDAM_FALLBACK, [center, points]);

  return (
    <div style={{ height: "70vh" }} className="border border-[var(--ink-200)] bg-[var(--surface-alt)]" data-testid="map-view-container">
      <MapContainer center={initial} zoom={7} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FitBounds points={points} />
        {placed.map((l) => (
          <Marker key={l.id} position={[l.lat, l.lng]} icon={brickIcon}>
            <Popup>
              <div style={{ minWidth: 180 }}>
                {l.image_paths?.[0] && <img src={fileUrl(l.image_paths[0])} alt={l.title} style={{ width: "100%", height: 110, objectFit: "cover", marginBottom: 8 }} />}
                <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 500, fontSize: 15 }}>{l.title}</div>
                <div style={{ fontSize: 11, color: "#454541", margin: "4px 0" }}>
                  {getCategoryLabel(l.category, lang)} · {l.quantity} {getUnitLabel(l.unit, lang)}
                </div>
                <div style={{ fontSize: 11, color: "#454541" }}>{l.location}</div>
                {l.distance_km != null && <div style={{ fontSize: 11, color: "#C5533B", marginTop: 4 }}>{l.distance_km} {t("map.kmAway")}</div>}
                <Link to={`/listings/${l.id}`} style={{ display: "inline-block", marginTop: 8, fontSize: 11, color: "#C5533B", textTransform: "uppercase", letterSpacing: "0.1em", fontFamily: "'IBM Plex Mono',monospace" }} data-testid={`map-popup-view-${l.id}`}>
                  {t("map.viewListing")}
                </Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
